import { OrgPermissions, DeviceAssignKeys } from 'utils/permissions';

/**
 * The `device_assign_*` keys an org actually offers.
 *
 * An org with NONE of them offers ALL of them: the keys only arrived with the "Devices options"
 * checklist and were never backfilled onto orgs that already had `devices` enabled, so an empty set
 * means "never configured", not "offers nothing".
 */
export const getEligibleDeviceAssignKeys = modules => {
    const list = Array.isArray(modules) ? modules : [];
    const anyConfigured = DeviceAssignKeys.some(k => list.includes(k));

    return DeviceAssignKeys.filter(k => !anyConfigured || list.includes(k));
};

export const getDeviceAssignEligibility = modules => {
    const eligible = getEligibleDeviceAssignKeys(modules);
    const allow = key => eligible.includes(key);

    return {
        occupants: allow(OrgPermissions.DEVICE_ASSIGN_OCCUPANTS),
        propertyGuests: allow(OrgPermissions.DEVICE_ASSIGN_PROPERTY_GUESTS),
        invitedOccupants: allow(OrgPermissions.DEVICE_ASSIGN_INVITED_OCCUPANTS),
        operators: allow(OrgPermissions.DEVICE_ASSIGN_OPERATORS),
        orgGuests: allow(OrgPermissions.DEVICE_ASSIGN_ORG_GUESTS)
    };
};
